import * as React from 'react';
import '../../assets/styles/pantallaCarga.css'

class PantallaCarga extends React.Component {

  render() {
    const { mensaje, progress, open } = this.props;
    const hasProgress = progress !== null && progress !== undefined;

    if (!open) {
      return null;
    }

    return (
      <div className="loading-modal-overlay">
        <div className="loading-modal-container">
          <div className="loading-modal-body">
            {hasProgress ? (
              <div className="loading-modal-content loading-modal-content--progress">
                <div className="loading-modal-message-container">
                  <h6>{mensaje != null ? mensaje : "Procesando"}</h6>
                </div>
                <div className="loading-modal-progress-track">
                  <div
                    className="loading-modal-progress-fill"
                    style={{ width: `${progress}%` }}
                  />
                </div>
                <span className="loading-modal-progress-pct">{progress}%</span>
              </div>
            ) : (
              <div className="loading-modal-content">
                <div className="loading-modal-spinner-container">
                  <div className="loading-modal-spinner"></div>
                </div>
                <div className="loading-modal-message-container">
                  <h6>{mensaje != null ? mensaje : "Procesando"}</h6>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PantallaCarga;